<template>

   <v-app>
      <div class="animated fadeIn">
         <h1>{{ $t('nav.zoho2prestige') }}</h1>

         <ddoWaiting :value="loading" color="primary" :message="$t('texts.loading')"/>

         <template>

            <CardUpdatableMyZoho ref="myZoho" 
               :row="levels[0].row" 
               :depth="levels[0].level" 
               :level="levels[0]"
               @errors="refresh_errors"
            >
            </CardUpdatableMyZoho>

         </template>

      </div>
   </v-app>
</template>

<script>
import Vue from 'vue';
import i18n from '@/plugins/i18n.js';
import ddoAlert from '@/components/ddoAlert.vue';
import ddoWaiting from '@/components/ddoWaiting.vue'
import BasicList from '@/views/BasicList.vue';
import CardUpdatableMyZoho from '@/components/partials/CardUpdatableMyZoho.vue';

export default {
   name: 'myZoho',
   mixins: [BasicList],
   components: {
      ddoAlert,
      ddoWaiting,
      CardUpdatableMyZoho,
   },
   data: () => {
      return {
         _this: null,
         loading: false,

         levels: [
         {
            api_code: 'customers',
            api_prefix: 'cus',
            row: {},
            level: 0,
            errors: [],
            columns: [],
            options: {
               showChildRowToggler: false,
               withChild: false,
               hiddenColumns: [],
               headings: {},
               texts: {
               },
               uniqueKey: 'shc_pk',
               filterable: false,
               columnsDropdown: false,
               customFilters: [],
            },
            callbacks: {
            },
            dialogValues: {
               headers: {
               },
               macros: [],
               samePLF: true,
               dialogShow: false,
               form_disabled: false,
               form_close: true,
               form_create: false,
               form_update: false,
               form_delete: false,
               disable_create: false,
               disable_update: false,
               disable_delete: false,
               header_value_function: function(row) { return null; }
            },
         },
         ],
      }
   },

   created() {
      this._this = this;
   },

   async mounted() {
   },

   methods: {
   },

}
</script>
